import { FaBook, FaClipboardList, FaUserGraduate } from "react-icons/fa";

export const STEPS = [
  { number: 1, title: "Subject & Time", icon: FaBook },
  { number: 2, title: "Topics", icon: FaClipboardList },
  { number: 3, title: "Select Tutors", icon: FaUserGraduate },
];

export const EMPTY_TIME_SLOT = {
  date: "",
  start: "09:00",
  end: "10:00",
};

export const INITIAL_FORM_STATE = {
  subjectId: "",
  preferredTimes: [{ ...EMPTY_TIME_SLOT }],
  selectedTutorIds: [],
  useRandom: false,
  sessionType: "online",
  location: "",
  topicsToFocus: "",
};

export const normalizeApiError = (err) =>
  err?.response?.data?.message ||
  err?.message ||
  "An unexpected error occurred";
